import React, { useRef, useEffect, useState } from "react";
import { image } from "../../Assets";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Marquee from "react-fast-marquee";
import "./style.scss";
import BookCall from "../BookCall/BookCall";

gsap.registerPlugin(ScrollTrigger);

const HeroSection = () => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const totalSlides = 3;

  const heroTexts = [
    "Johns Hopkins Student Center",
    "Montgomery College Library",
    "Inova Alexandria Hospital at Landmark",
  ];

  const getScaleClass = (index) => {
    if (index === activeIndex)
      return "tw-scale-[1] tw-opacity-100 tw-font-semibold";
    if (index === activeIndex + 1)
      return "tw-scale-[0.9] tw-opacity-80";
    if (index === activeIndex + 2)
      return "tw-scale-[0.5] tw-opacity-70";
    return "tw-scale-[0.7] tw-opacity-40";
  };

  const animation = () => {
    gsap.timeline()
      // .fromTo(".hero h2", { x: "-200%", opacity:"0"}, { x: "0%",opacity:"1", duration: 0.6 })
   
  };

  const [openModal, setOpenModal] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    animation();
  }, []);

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.activeIndex);
    animation();
  };

    useEffect(() => {
      const handleClickOutside = (event) => {  
        if (openModal && modalRef.current && !modalRef.current.contains(event.target)) {
          setOpenModal(false);
        }
      };
  
      const handleEsc = (event) => {
        if (event.key === "Escape") setOpenModal(false);
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("keydown", handleEsc);
  
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        document.removeEventListener("keydown", handleEsc);
      };
    }, [openModal]);

  return (
    <>
    <div className="tw-relative tw-overflow-hidden ">

      {/* 🔹 VERTICAL TEXT INDICATOR */}
      {/* <div className="tw-absolute tw-bottom-24 tw-right-10 sm:tw-right-20 tw-z-20 tw-hidden tw-flex-col tw-gap-0 tw-items-start md:tw-flex">
        {heroTexts.map((text, index) => (
          <span
            key={index}
            onClick={() => swiperRef.current?.slideTo(index)}
            className={`tw-cursor-pointer tw-origin-left tw-text-sm sm:tw-text-base tw-text-white tw-transition-all tw-duration-300 ${getScaleClass(
              index
            )}`}
          >
            {text}
          </span>
        ))}
      </div> */}

      {/* 🔹 MASK WRAPPER (STATIC SHAPE) */}
      <div className="hero-mask-wrapper tw-relative">
        <div className="hero-mask">

          <Swiper
            slidesPerView={1}
            centeredSlides
            onSlideChange={handleSlideChange}
            autoplay={{ delay: 8000, disableOnInteraction: false }}
            modules={[Navigation, Autoplay, Pagination]}
            onBeforeInit={(swiper) => (swiperRef.current = swiper)}
            className="tw-h-[500px] sm:tw-h-[60vh] md:tw-h-[800px] tw-flex tw-items-center tw-text-white"
          >
            {[1, 2, 3].map((slide) => (
              <SwiperSlide key={slide}>
                <section
                  className={`slider-${slide} hero tw-h-full tw-bg-cover tw-bg-center tw-flex tw-items-center`}
                >
                  <div className="container tw-max-w-[1320px] tw-mx-auto tw-px-4 sm:tw-px-6 md:tw-px-0">
                    <div className="tw-grid tw-grid-cols-12">
                      <div className="tw-col-span-10 lg:tw-col-span-6  md:tw-col-span-8 sm:tw-col-span-6">
                        <h2 className="tw-text-2xl sm:tw-text-3xl md:tw-text-4xl lg:tw-text-[40px] tw-font-semibold tw-mb-4">
                          Transforming Construction Through Precision and Digital
                          Expertise
                        </h2>
                        <p className="tw-text-sm sm:tw-text-base tw-mb-6">
                          Fractile Studio partners with AEC teams to modernize
                          workflows, strengthen coordination, and deliver project
                          outcomes with unmatched accuracy.
                        </p>
                        <button className="btn-2-white !tw-px-10 tw-py-3 tw-border-2 tw-border-white tw-transition-all" 
                        onClick={() => setOpenModal(true)}>
                          Discuss Your Project
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* 🔹 PAGINATION (CLICKABLE) */}
          <div className="tw-absolute sm:tw-top-1/2 sm:tw-bottom-0 tw-bottom-8 tw-h-[0] sm:tw-h-[80px] sm:-tw-translate-y-1/2 tw-right-6 sm:tw-right-40 tw-flex tw-flex-row sm:tw-flex-col tw-gap-3 tw-z-20">
            {[...Array(totalSlides)].map((_, index) => (
              <button
                key={index}
                onClick={() => swiperRef.current?.slideTo(index)}
                className={`tw-w-4 tw-h-3 tw-skew-x-[-20deg] tw-border tw-transition-all ${
                  activeIndex === index
                    ? "tw-bg-white tw-scale-125"
                    : "tw-bg-white/20"
                }`}
              />
            ))}
          </div>

        </div>

      {/* 🔹 MARQUEE WITH DIFFERENT SHAPE MASK */}
      <div className="tw-absolute tw-bottom-0 md:tw-left-4 tw-left-[-20px] tw-w-1/2 tw-z-0">
        <div className="marquee-mask-wrapper">
          <div className="marquee-mask">
            <div className="tw-py-3 tw-overflow-hidden">
              <Marquee>
                <div className="tw-flex tw-gap-[60px] sm:tw-gap-[100px] tw-pr-10">
                  {[image.logo1, image.logo2, image.logo3, image.logo4, image.logo5, image.logo6]
                    .concat([image.logo1, image.logo2, image.logo3])
                    .map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        className="tw-w-[80px] md:tw-w-auto"
                      />
                    ))}
                </div>
              </Marquee>
            </div>
          </div>
        </div>
      </div>
      </div>    

    </div>

    <BookCall isOpen={openModal} onClose={() => setOpenModal(false)}/>

    </>

  );
};

export default HeroSection;
